import { CameraType } from '../enums/cameraType';
import { Event } from '../interfaces';
import { isDefined } from './isDefined';

export const isContextCamera = (event: Event): boolean => {
  return event.metadata?.event_detection_camera === CameraType.Context;
};

export const isMultiCameraSystem = (event: Event): boolean => {
  return isDefined(event.metadata?.lpr_camera_idx);
};
